import { Navigate } from 'react-router-dom';
import { useClienteAuthStore } from '@/stores/clienteAuthStore';

export function ClienteProtectedRoute({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useClienteAuthStore((s) => s.isAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to="/cliente/login" replace />;
  }

  return <>{children}</>;
}
